const baseURL = 'https://algoexpert.herokuapp.com'

export {baseURL}